export const Languages = {
  en: 'EN',
  'zh-Hant': '繁中',
  'zh-Hans': '简中'
}

export const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone
